import styled from 'styled-components';

export const Container = styled.div`
  background-color: white;
  padding: 21px 24px 25px 24px;
  box-shadow: inset 0 0 1px #eaeaea;
  margin-top: 25px;
  border-radius: 4px;
`;

export const Header = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: #2c2c2c;
`;

export const DateText = styled.span`
  color: #6e6e6e;
  font-style: italic;
  font-size: 10px;
  font-weight: 400;
`;

export const SubHeader = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #505050;
  font-size: 12px;
  border-bottom: 1px solid lightgray;
  padding-bottom: 3px;
  font-weight: lighter;

  span {
    font-weight: 300;
  }
`;

export const RequestLayout = styled.div`
  font-size: 12px;
`;

export const Left = styled.div`
  min-width: 100px;
  max-width: 145px;
  display: flex;
  align-items: center;
`;

export const CircleStatus = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${({ color }) => color || 'white'};
  box-shadow: ${({ color }) => !color && `inset 0 0 1px #707070`};
`;

export const RequestDescription = styled.div`
  width: 135px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;

  span {
    text-decoration: none;
    color: inherit;

    &:hover {
      text-decoration: none;
      color: inherit;
    }
  }

  span {
    margin-left: 6px;
    font-weight: 300;
  }

  ._spectrum-ActionButton_7a745 {
    border: none;
    padding: 0;
    margin: 0;
    background: none;
  }

  ._spectrum-ActionButton_7a745 {
    border: none;
    padding: 0;
    margin: 0;
    background: none;
  }
`;

export const Right = styled.div`
  width: 119px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 50%;

  i {
    text-align: start;
    font-size: 12px;
    color: #323232;
    padding-left: 10px;
    font-weight: 300;
  }

  span {
    text-align: end;
    font-weight: bold;
    color: #323232;
  }
`;
